import React, { Component } from 'react';
import { Button, Header } from 'semantic-ui-react'
import axios from 'axios'
import { getNowFormatted, updateOrder } from '../../../../Utilities/FireBaseUtils'
import { serverIp, firebaseAuth, base, getOrderKey } from '../../../../config/constants.js'
import { checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';


export class ShirtFoundSingleOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: ''
        }

        this.checkIfAllShirtsAvail = this.checkIfAllShirtsAvail.bind(this);
    }

    componentDidMount() {

        //LOAD USER
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                this.getFacets();

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    admin: false,
                    user: user,
                    uid: user.uid
                })
            }

        })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }


    updateShirtFoundOrder = () => {
        console.log("+++++:updateShirtFoundOrder")

        var d = new Date();
        let orderUpdate = {
            shirtFound: 'yes',
            shirtFoundUpdateBy: this.state.user.email,
            shirtFoundUpdate: getNowFormatted(),
        }

        base.update('orders/' + this.props.mainOrder.key + '/singleOrders/' + this.props.singleOrder.key, {
            // data: {uid: userUid},
            data: orderUpdate,
            then: (err) => {
                if (!err) {
                    console.log("updated updateShirtFoundOrder order no error");

                  //  this.checkIfAllShirtsAvail();
                    this.sendReportinApiOrderUpdate();
                }
            }

        });

        // updateOrder(this.props.order.key,orderUpdate);
    }

    updateBuyShirt = () => {
        console.log("+++++:updateBuyShirt")

        var d = new Date();
        let orderUpdate = {
            shirtFound: 'buy',
            shirtFoundUpdateBy: this.state.user.email,
            shirtFoundUpdate: getNowFormatted(),
        }

        base.update('orders/' + getOrderKey(this.props.mainOrder) + '/singleOrders/' + this.props.singleOrder.key, {
            // data: {uid: userUid},
            data: orderUpdate,
            then: (err) => {
                if (!err) {
                    console.log("updated updateBuyShirt order no error");

                    this.sendBuyShirtToApi();
                }
            }

        });

        // updateOrder(this.props.order.key,orderUpdate);
    }

    sendBuyShirtToApi = () => {
        console.log("sfx1 +++++++++:sendBuyShirtToApi");
        axios.post(serverIp + 'shirts/markShirtToBeBought', {
            // axios.post('http://localhost:8080/PrintBReporting/webresources/orders/updateOrder', {
            apiKey: 'PrintB@da7',
            orderId: this.props.mainOrder.key,
            singleOrderKey: this.props.singleOrder.key,
            adminEmail: this.state.user.email
        })
            .then(function (response) {
                console.log(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    sendReportinApiOrderUpdate = () => {
        console.log("sfx1 +++++++++:sendReportinApiOrderUpdate");
        axios.post(serverIp + 'shirts/markShirtsAvail', {
            // axios.post('http://localhost:8080/PrintBReporting/webresources/orders/updateOrder', {
            apiKey: 'PrintB@da7',
            orderId: this.props.mainOrder.key,
            singleOrderKey: this.props.singleOrder.key,
            qty: this.props.singleOrder.qty,
            shirtColor: this.props.singleOrder.shirtColor,
            shirtSize: this.props.singleOrder.shirtSize,
            shirtType: this.props.singleOrder.shirtType,
            adminEmail: this.state.user.email
        })
            .then(function (response) {
                console.log(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    checkIfAllShirtsAvail = () => {
        console.log("mbx1 ++++++++++++;checkIfAllShirtsAvail");
        base.fetch('orders/' + this.props.mainOrder.key + '/singleOrders', {
            context: this,
            asArray: true,
            then(data) {
                console.log("rlx141 order:" + JSON.stringify(data, null, 3));

                let tempOrder = data;
                let allShirtsAvail = false;

                let singleOrders = data;

                console.log('mbx2 starting loop:' + singleOrders.length);
                for (var i = 0; i < singleOrders.length; i++) {

                    console.log('mbx3 inside loop:');

                    if (singleOrders[i].shirtFound) {
                        console.log("mbx4 order1 shirt found is true");
                        allShirtsAvail = true;
                    } else {
                        console.log("mbx5 order1 shirt found is false");
                        allShirtsAvail = false;
                    }
                }

                console.log("stxFinal: allShirtsAvail:" + allShirtsAvail);

                if (allShirtsAvail) {
                    console.log("+++++++: allShirtsAvail is true");
                    var d = new Date();

                    let orderUpdates = {
                        status: 'shirt_found',
                        lastUpdated: getNowFormatted(),
                        lastUdpatedSecs: d.getTime(),
                        updatedBy: this.state.user.email
                    }

                    updateOrder(this.props.mainOrder.key, orderUpdates)
                }

            }
        });
    }

    render() {

        const buyShirtConst = this.props.singleOrder.shirtFound === 'buy'

            ? <Header color='orange' as='h4'>TO BE BOUGHT</Header>
            : <Button onClick={this.updateBuyShirt}>BUY SHIRT </Button>

        const showBuyShirt  = this.props.singleOrder.shirtFound === 'yes'
            ? ''
            : this.props.singleOrder.shirtFound === 'buy'

            ? <Header color='orange' as='h4'>TO BE BOUGHT</Header>
            : <Button onClick={this.updateBuyShirt}>BUY SHIRT </Button>

        const shirtAvailConst = this.props.singleOrder.shirtFound && this.props.singleOrder.shirtFound === 'yes'

            ? <Header color='green' as='h4'>SHIRT AVAIL</Header>
            : <Button color='BLUE' onClick={this.updateShirtFoundOrder}>SHIRT FOUND</Button>

        return (
            <div>
                {showBuyShirt}
                {shirtAvailConst}
            </div>
        )
    }
}

export default ShirtFoundSingleOrder;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ShirtFound/ShirtFoundSingleOrderForArrays.js